const BaseURL = {
  //localhost
  // nodeapi: "http://localhost:3006/",
  //live
  nodeapi: "https://api.cms.rightdirectionacademy.com/"
};

export default BaseURL;
